<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="(subcontractor.subcontractor_id ? 'Edit Subcontractor: ' + subcontractor.subcontractor_id : 'New Subcontractor') + ' :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/subcontractors`">
                            <i class="fa fa-id-badge"></i> Subcontractors
                        </router-link>
                    </li>
                    <template v-if="subcontractor_id">
                        <li class="breadcrumb-item font-weight-light">
                            <router-link :to="`/subcontractors/view/${subcontractor_id}`">
                                {{ subcontractor.subcontractor_name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active">Edit</li>
                    </template>
                    <template v-else>
                        <li class="breadcrumb-item active">New Subcontractor</li>
                    </template>
                </ol>
            </h4>

            <div class="row">
                <div class="col-lg-8 col-md-10">
                    <div class="card mb-3">
                        <div class="card-header">Subcontractor Details</div>
                        <div class="card-body">
                            <div class="form-group row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Name: <i class="fa fa-asterisk text-danger"></i></label>
                                <div class="col-sm-8">
                                    <input type="text" v-model="subcontractor.subcontractor_name" :class="{'form-control': true, 'is-invalid': errors.subcontractor_name}" placeholder="Subcontractor Name" />
                                    <span v-if="errors.subcontractor_name" class="text-danger">
                                        <span v-for="error in errors.subcontractor_name">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.valid_until }" class="row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Approved Until:</label>
                                <div class="col-sm-8">
                                    <date-picker v-model="valid_until" :config="{format: 'MM/DD/YYYY', useCurrent: false}" :class="{ 'is-invalid': errors.valid_until }" placeholder="Approved Until"></date-picker>
                                    <span v-if="errors.valid_until" class="text-danger">
                                        <span v-for="error in errors.valid_until">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.subcontractor_name }" class="row">
                                <div class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">
                                    OSHA Exempt:
                                </div>
                                <div class="col-sm-8 pt-2">
                                    <b-form-checkbox v-model="subcontractor.is_osha_exempt" value="1" unchecked-value="0" plain>
                                        This subcontractor is exempt from being required to provide OSHA data.
                                    </b-form-checkbox>

                                    <div v-if="errors.is_osha_exempt" class="text-danger">
                                        <span v-for="error in errors.is_osha_exempt">{{ error }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label :class="{ 'col-lg-2 col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.status_id }">Status: <i class="fa fa-question-circle" title="Status is a controlled field that cannot be edited directly"></i></label>
                                <div class="col-md-8 mt-2">
                                    <label :class="`badge badge-${subcontractor.status.status_color}`">{{ subcontractor.status.status_name }}</label>
                                </div>
                            </div>

                            <div v-if="typeof subcontractor.subcontractor_id == 'undefined'" class="form-group row">
                                <label class="col-lg-2 col-md-3 col-form-label text-sm-right">Create New User:</label>
                                <div class="col-md-8 mt-2">
                                    <b-checkbox v-model="add_new_user" plain />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-success" v-on:click="saveSubcontractor(this)" :disabled="saving">
                <span v-if="subcontractor_id">Update</span>
                <span v-else>Create</span>
                Subcontractor
            </button>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data() {
            return {
                loading: true,
                saving: false,
                subcontractor_id: this.$route.params.id,
                subcontractor: {},
                statuses: [],
                errors: {},
                add_new_user: false,

                valid_until: null,
            }
        },

        methods: {
            //Get the Various Resources We Need to Edit a Subcontractor
            getErrorClass(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },

            getSubcontractor() {
                //Get the data
                this.$http
                    .get('subcontractors/edit' + (this.subcontractor_id ? '/' + this.subcontractor_id : ''))
                    .then(response => {
                        //Set all the data
                        this.subcontractor = response.data.subcontractor;
                        this.statuses = response.data.statuses;

                        if (this.subcontractor.valid_until)
                        {
                            this.valid_until = moment(this.subcontractor.valid_until, 'YYYY-MM-DD').format('MM/DD/YYYY');
                        }

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveSubcontractor() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                if (this.valid_until)
                {
                    this.subcontractor.valid_until = moment(this.valid_until, 'MM/DD/YYYY').format('YYYY-MM-DD');
                }

                //Send it
                this.$http
                .post('subcontractors/edit' + (this.subcontractor_id ? '/' + this.subcontractor_id : ''), this.subcontractor)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Subcontractor Saved');

                    //Return to main list?
                    if (this.add_new_user)
                        this.$router.push('/users/create?sub_id='+response.data.subcontractor_id);
                    else
                        this.$router.push('/subcontractors/view/' + response.data.subcontractor_id);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the subcontractors
            this.getSubcontractor();
        }
    }
</script>
